const { getCILSuccessMessage } = require("../../helpers/getCILSuccessMessage");

function changeAriaHidden ($, val) {
  if ($(".top-bar")) $(".top-bar").attr("aria-hidden", val);
  if ($(".main-layout")) $(".main-layout").attr("aria-hidden", val);
  if ($(".password-recovery-modal")) $(".password-recovery-modal").attr("aria-hidden", !val);
}

var CheckInLaterModal = Backbone.Epoxy.View.extend({
  template: 'modals.checkInLater',

  events: {
    'click .js-checkInLaterProceed': 'proceed',
    'keydown .js-checkInLaterProceed': 'proceed',
    'click .js-checkInLaterClose': 'closeModal',
    'keydown .js-checkInLaterClose': 'closeModal',
    'click .js-checkInLaterSubmit': 'submit',
    'keydown .js-checkInLaterSubmit': 'submit',
  },

  initialize: function() {
    this.hasRendered = false;
  },

  cleanup: function() {
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  /**
   * Boilerplate after render for modals.
   */
  afterRender: function() {
    this.$el.modal({
      show: false
    });

    this.$el.on('hide.bs.modal', function() {
      changeAriaHidden($, false);

      if ('parentIFrame' in window) {
        parentIFrame.sendMessage({event: 'closeModal'});
        $('body').css('background', 'transparent');
      }
    });
    this.applyBindings();
  },

  /**
   * Show this form.
   */
  show: function(params) {
    this.model.set('step', params.step);
    this.model.set('checkinData', params.checkinData || null);
    this.model.set('availableSlots', params.availableSlots || []);
    this.model.set('preferredTime', params.availableSlots && params.availableSlots.length > 0 ? params.availableSlots[0].value : null);

    this.$el.modal('show');

    changeAriaHidden($, true);
    if ('parentIFrame' in window) {
      parentIFrame.sendMessage({event: 'openModal'});
      $('body').css('background', '#fbfbfb');
    }

    this.$('#checkInLaterProceed').focus();
  },

  proceed: function (e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
      this.model.set('step', 2);
    }
  },

  submit: function (e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
      var options = {
        message: '',
        cancelLabel: '',
        confirmLabel: 'Ok',
        showCancelLabel: false
      };

      var checkinData = this.model.get('checkinData');
      var preferredTime = this.model.get('preferredTime');

      if (!preferredTime  || preferredTime < 0) {
        options.message = 'Please select preferred time';
        bookedby.app.confirmForm.show(function() {}, function() {}, options);
        return;
      }

      checkinData.preferredTime = preferredTime;

      $.ajax({
        url: bookedby.routes.BOOKING.CHECK_IN_LATER,
        contentType: 'application/json',
        data: JSON.stringify(checkinData),
        method: 'POST',
        dataType: 'json',
        success: _.bind(function(data) {
          if (!data.success && data.userError) {
            options.message = data.error;
            bookedby.app.confirmForm.show(function() {}, function() {}, options);
          } else if (!data.success) {
            bookedby.app.logAPIError(data.error);

            if (data.errorType == 'noAuthentication') {
              bookedby.app.logOut(); // force logout in this session
              options.message = 'Please log in again in order to book the appointment';
              bookedby.app.confirmForm.show(function() {}, function() {}, options);
            } else {
              options.message = data.error;
              bookedby.app.confirmForm.show(function() {}, function() {}, options);
            }
          } else {
            this.model.set('successMessage', getCILSuccessMessage(preferredTime, data.cilRequestUpdated));
            this.model.set('step', 3);
          }
        }, this),
        error: _.bind(function(jqXHR, textStatus, textError) {
          bookedby.app.logAPIError(textError);
          this.state = 'error';
          this.render();
        }, this)
      });

    }
  },

  closeModal: function(e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
      this.$el.modal('hide');
    }
  }
});

module.exports = CheckInLaterModal;
